var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('div',{staticStyle:{"max-width":"1200px","margin":"0 auto"}},[_c('task-video-cards',{attrs:{"tasks":_vm.tasks},on:{"task-clicked":_vm.handleTaskClick}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hero-section"},[_c('div',{staticClass:"container"},[_c('h1',{staticClass:"page-title"},[_vm._v("Гарын авлага")]),_c('p',{staticClass:"page-subtitle"})])])
}]

export { render, staticRenderFns }